import { motion } from 'framer-motion'
import { LucideIcon } from 'lucide-react'

export interface StatCard {
  title: string
  value: string
  currency?: string
  change: string
  trend: 'up' | 'down'
  icon: LucideIcon
}

interface StatsCardsProps {
  stats: StatCard[]
}

export function StatsCards({ stats }: StatsCardsProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6"
    >
      {stats.map((stat, index) => {
        const IconComponent = stat.icon
        
        return (
          <motion.div
            key={stat.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white rounded-xl p-4 shadow-sm border border-gray-100"
          >
            <div className="flex items-center justify-between mb-2">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                stat.trend === 'up' ? 'bg-success/10' : 'bg-error/10'
              }`}>
                <IconComponent className={`h-5 w-5 ${
                  stat.trend === 'up' ? 'text-success' : 'text-error'
                }`} />
              </div>
              <span className={`text-sm font-medium ${
                stat.trend === 'up' ? 'text-success' : 'text-error'
              }`}>
                {stat.change}
              </span>
            </div>
            <h3 className="text-2xl font-bold text-text-primary mb-1">
              {stat.value} {stat.currency && <span className="text-sm text-text-secondary">{stat.currency}</span>}
            </h3>
            <p className="text-sm text-text-secondary">{stat.title}</p>
          </motion.div>
        )
      })}
    </motion.div>
  )
}

